(function () {
  'use strict';

  // Rychlá rezervace: přesměruje na stránku vybrané aktivity s datem a počtem osob
  document.querySelectorAll('[data-booking-bar]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var select = form.querySelector('[name="activity"]');
      var url = select && select.value;
      if (!url) return;
      var params = new URLSearchParams();
      var date = form.querySelector('[name="date"]');
      var people = form.querySelector('[name="people"]');
      if (date && date.value) params.set('date', date.value);
      if (people && people.value) params.set('people', people.value);
      var q = params.toString();
      window.location.href = url + (q ? (url.indexOf('?') > -1 ? '&' : '?') + q : '');
    });
  });

  // Množství +/-
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var min = parseInt(input.min || '0', 10);
        var v = (parseInt(input.value, 10) || 0) + step;
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Galerie produktu
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product__main-media img');
    if (!main) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        main.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Varianty produktu
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var button = form.querySelector('[data-add-button]');
    var labels = { add: button.getAttribute('data-label-add'), sold: button.getAttribute('data-label-sold'), unavailable: button.getAttribute('data-label-unavailable') };
    var money = form.getAttribute('data-money-format') || '{{amount}} €';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var formatted = withSep + ',' + parts[1];
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, formatted);
    }

    function update() {
      var selects = form.querySelectorAll('[data-option-index]');
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) {
        button.disabled = true;
        button.textContent = labels.unavailable;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        compareEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      }
      button.disabled = !variant.available;
      button.textContent = variant.available ? labels.add : labels.sold;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.querySelectorAll('[data-option-index]').forEach(function (s) { s.addEventListener('change', update); });
  });

  // Řazení kolekce
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Zavřít menu na mobilu po kliknutí
  document.querySelectorAll('.menu-drawer a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details');
      if (d) d.removeAttribute('open');
    });
  });
})();
(function(){var K='ay_lang_chosen';function g(s,k){try{return s.getItem(k)}catch(e){return null}}function p(s,k,v){try{s.setItem(k,v)}catch(e){}}document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('.lang-menu__panel button');if(b)p(localStorage,K,b.value);var o=document.querySelector('.lang-menu[open]');if(o&&!o.contains(e.target))o.removeAttribute('open')});if(g(localStorage,K)||g(sessionStorage,'ay_lang_auto'))return;if(/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent))return;var r=window.Shopify&&Shopify.routes&&Shopify.routes.root;if(r!=='/')return;var f=document.querySelector('.lang-menu__panel');if(!f)return;var a=[].map.call(f.querySelectorAll('button'),function(x){return x.value});var cur=(document.documentElement.lang||'').slice(0,2).toLowerCase();var L=navigator.languages||[navigator.language||''];for(var i=0;i<L.length;i++){var c=(L[i]||'').slice(0,2).toLowerCase();if(c===cur)return;var m=a.filter(function(v){return v.slice(0,2).toLowerCase()===c})[0];if(m){p(sessionStorage,'ay_lang_auto','1');var h=document.createElement('input');h.type='hidden';h.name='locale_code';h.value=m;f.appendChild(h);f.submit();return}}})();
(function(){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';if(r==='/')return;var b=r.replace(/\/$/,'');document.querySelectorAll('.site-header a[href^="/"],.site-footer a[href^="/"],.rte a[href^="/"]').forEach(function(a){var h=a.getAttribute('href');if(h.indexOf('//')===0||h.indexOf(r)===0||h===b)return;a.setAttribute('href',b+h)})})();